import React, { useState } from 'react';
import { useEditMode } from '../contexts/EditModeContext';
import EditableText from './EditableText';

function YouAreInvited({ invitation, setInvitation }) {
  const { isEditMode } = useEditMode();
  const [uploading, setUploading] = useState({});
  
  const invitationData = invitation || {
    title: "You Are Invited",
    text: "We are thrilled to invite you to celebrate our special day with us.",
    images: []
  };

  const compressImage = (file, maxWidth = 800, quality = 0.8) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: 'image/jpeg' }));
          }, 'image/jpeg', quality);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  };

  const handleImageAdd = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const tempId = Date.now();
      setUploading(prev => ({ ...prev, [tempId]: true }));

      try {
        const compressedFile = await compressImage(file);
        const formData = new FormData();
        formData.append('photo', compressedFile);
        formData.append('type', 'invitation');

        const response = await fetch('/api/upload-image', {
          method: 'POST',
          body: formData
        });
        const data = await response.json();
        
        if (data.success) {
          setInvitation({ 
            ...invitationData, 
            images: [...invitationData.images, data.image.url] 
          });
        }
      } catch (error) {
        console.error('Failed to upload image:', error);
      } finally {
        setUploading(prev => {
          const newUploading = { ...prev };
          delete newUploading[tempId];
          return newUploading;
        });
      }
    }
  };

  const handleImageRemove = (index) => {
    const newImages = invitationData.images.filter((_, i) => i !== index);
    setInvitation({ ...invitationData, images: newImages });
  };

  return (
    <section className="section" id="invitation">
      <EditableText
        value={invitationData.title}
        onChange={(val) => setInvitation({ ...invitationData, title: val })}
        className="section-title"
        tag="h2"
        html={true}
      />
      <EditableText
        value={invitationData.text}
        onChange={(val) => setInvitation({ ...invitationData, text: val })}
        className="invitation-text"
        tag="p"
        html={true}
      />
      <div className="invitation-images">
        {invitationData.images.map((img, index) => (
          <div key={index} className="invitation-image-wrapper">
            <img 
              src={img} 
              alt={`Invitation ${index + 1}`} 
              className="invitation-image"
              loading="lazy"
            />
            {isEditMode && (
              <button
                onClick={() => handleImageRemove(index)}
                className="invitation-image-remove"
              >
                ×
              </button>
            )}
          </div>
        ))}
        {Object.keys(uploading).map(id => (
          <div key={id} className="invitation-image-wrapper">
            <div className="invitation-image-placeholder">Uploading...</div>
          </div>
        ))}
        {isEditMode && (
          <div className="invitation-image-wrapper invitation-add-wrapper">
            <label className="invitation-add-button">
              <span>+</span>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageAdd}
                style={{ display: 'none' }}
              />
            </label>
          </div>
        )}
      </div>
    </section>
  );
}

export default YouAreInvited;
